import { render, staticRenderFns } from "./toWaitDepart.vue?vue&type=template&id=2e14c880&scoped=true&"
import script from "./toWaitDepart.vue?vue&type=script&lang=js&"
export * from "./toWaitDepart.vue?vue&type=script&lang=js&"
import style0 from "./toWaitDepart.vue?vue&type=style&index=0&id=2e14c880&prod&lang=scss&scoped=true&"
import style1 from "./toWaitDepart.vue?vue&type=style&index=1&id=2e14c880&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e14c880",
  null
  
)

export default component.exports